import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}>
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function Vectorization() {

    const vectorizationSteps = [
        { number: "01", title: "Submit Your Image", description: "Send us your logo or artwork in JPG, PNG, PDF, or any raster format.", icon: "📤" },
        { number: "02", title: "Vector Conversion", description: "Our designers convert your image into a clean and scalable vector file.", icon: "⚡" },
        { number: "03", title: "Detail Refinement", description: "We refine lines, colors, and shapes to ensure accuracy and quality.", icon: "✓" },
        { number: "04", title: "Final Delivery", description: "Receive your files in AI, EPS, SVG, or other required vector formats.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Vector Art & Logo Vectorization Services in Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Get professional vector art and logo vectorization services in Los Angeles, CA. Convert images to high-quality vector files. Fast turnaround. Order now!" />
                <meta name="keywords" content="vector art services, logo vectorization service, raster to vector conversion, image to vector, convert logo to vector, vectorization services Los Angeles, vector art near me, vector conversion services CA" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Vectorization</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Vectorization</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/vectorization1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Clean Lines. Scalable Precision.</span>
                                <h3 className="case-study-title">Professional Vectorization Services in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we offer expert vectorization services in Los Angeles, California, helping businesses convert low-resolution images into high-quality, scalable vector files. Whether you have a logo, artwork, or graphic that needs to be resized without losing quality, our professional vector art services ensure clean lines, sharp edges, and perfect scalability.
                                </p>
                                <p className="case-study-description">
                                    Vector files are essential for printing, branding, and embroidery, as they maintain clarity across all sizes and formats. Our team specializes in logo vectorization services, transforming raster images such as JPG, PNG, or screenshots into precise vector formats like AI, EPS, and SVG. If you're searching for reliable vectorization services near you in Los Angeles, Grand Indigo Embroidery provides fast, accurate, and professional results tailored to your business needs.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Built for Print & Production</span>
                                <h3 className="case-study-title">High-Quality Logo Vectorization for Print & Embroidery</h3>
                                <p className="case-study-description">
                                    Our logo vectorization services are designed to support a wide range of applications, including screen printing, embroidery digitizing, promotional products, and digital branding. We understand that every detail matters, which is why we carefully recreate your artwork to ensure accuracy in colors, shapes, and proportions.
                                </p>
                                <p className="case-study-description">
                                    Whether you need raster to vector conversion, image cleanup, or complete logo redesign in vector format, we deliver files that are ready for production. Businesses across Los Angeles trust us for consistent quality and fast turnaround times. If you’re looking to convert your logo to vector online or need a local expert for vector art services, Grand Indigo Embroidery ensures your designs are production-ready and visually flawless.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/vectorization2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={vectorizationSteps} />


            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What are vectorization services?"
                                    answer="Vectorization services involve converting raster images like JPG or PNG into scalable vector files that maintain quality at any size."
                                />

                                <FaqItem
                                    question="Why do I need a vector file for my logo?"
                                    answer="Vector files are essential for printing, embroidery, and branding because they ensure your logo remains sharp and clear without pixelation."
                                />

                                <FaqItem
                                    question="Do you offer vectorization services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides professional vectorization services in Los Angeles, California, serving local businesses and online clients."
                                />

                                <FaqItem
                                    question="Can I convert my logo to vector online?"
                                    answer="Absolutely. You can easily submit your file and convert your logo to vector online with our fast and reliable service."
                                />

                                <FaqItem
                                    question="What file formats do you provide for vector art?"
                                    answer="We deliver vector files in AI, EPS, SVG, and PDF formats, depending on your requirements."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
